export type SocialAuthProvider = 'google' | 'apple';

export const SOCIAL_AUTH_LABELS: Record<SocialAuthProvider, string> = {
  google: 'Google',
  apple: 'Apple',
};

export function isSocialAuthEnabled(provider: SocialAuthProvider): boolean {
  const value =
    provider === 'google'
      ? import.meta.env.VITE_ENABLE_GOOGLE_AUTH
      : import.meta.env.VITE_ENABLE_APPLE_AUTH;

  return String(value).toLowerCase() === 'true';
}
